import * as React from 'react';
import {Container as MuiContainer} from '@mui/material';

const Container = (props: any) => {
    return <MuiContainer maxWidth="lg" {...props} />
}

export default Container;